import { render } from "./PersonalBankView.vue?vue&type=template&id=469cc69c&scoped=true"
import script from "./PersonalBankView.vue?vue&type=script&lang=js"
export * from "./PersonalBankView.vue?vue&type=script&lang=js"

import "./PersonalBankView.vue?vue&type=style&index=0&id=469cc69c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469cc69c"]])

export default __exports__